import './timestamp.css';
export default {
  "modifiers": {
    "helpText": "pf-m-help-text"
  },
  "timestamp": "pf-v5-c-timestamp"
};